<template>
  <div>
    <h2 class="font-weight-bold mb-4">Identification</h2>
    <div class="identification">
      <b-row>
        <b-col cols="12" sm="12" md="8" lg="8">
          <p>Please follow the instruction below:</p>
          <p class="font-weight-bold">Just follow these three easy steps:</p>
          <p>1. Place the Driver’s License in front of the camera (content should be readable)</p>
          <p>2. We don't admit blurry photos or photos with white spots</p>
          <p>3. Click on the button "Take a picture"</p>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <img class="avatar" src="@/assets/images/card.png" alt />
        </b-col>
      </b-row>
      <div class="pic_block mb-4"></div>
      <button class="verification">Take Picture</button>
      <p  class="maps"><b-link>You can go throw the process online or go to branch</b-link></p>
      <div class="d-flex justify-content-end mb-4 next">
        <!-- <button @click="$router.push('/registration/step-6/id')" type="submit">Next Step</button> -->
        <b-link to="/registration/step-7">Next Step</b-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.identification {
  .avatar {
    width: 100%;
    margin: auto;
    display: block;
    max-width: 231px;
  }
  .verification {
    width: 100%;
    height: 50px;
    border: 0;
    color: #fff;
    background: $base-blue-nav;
    border-radius: 4px;
    max-width: 420px;
    display: block;
    margin: auto;
  }
  .maps {
      text-align: center;
      margin-top: 30px;
  }
  .pic_block {
    width: 100%;
    height: 500px;
    background: #111;
    margin-top: 20px;
  }
}
</style>